module.exports = __webpack_public_path__ + "static/solidbook-wiki-23f701920cd5ce30a3fa2a01b36232ec.png";